import {library} from '@fortawesome/fontawesome-svg-core';

// import your icons

import {
    faStar,
    faHospitalAlt,
    faMapMarkerAlt,
    faPhoneAlt,
    faEnvelope,
    faStethoscope,
    faUserNurse,
    faHeartbeat,
    faNotesMedical,
    faArrowRight,
    faSearch,
    faSearchLocation,
    faArrowUp
} from '@fortawesome/free-solid-svg-icons';

import {
    fab,
    faFacebook,
    faTwitter,
    faPinterest,
    faInstagram,
    faGoogle
} from '@fortawesome/free-brands-svg-icons';

library.add(
    fab,
    faStar,
    faSearch,
    faArrowUp,
    faSearchLocation,
    faMapMarkerAlt,
    faPhoneAlt,
    faEnvelope,
    faStethoscope,
    faUserNurse,
    faHeartbeat,
    faNotesMedical,
    faArrowRight,
    faHospitalAlt,

    faFacebook,
    faTwitter,
    faPinterest,
    faInstagram,
    faGoogle
    // more icons go here
);